// 业务无关 原则上不存在任何import引入 禁止存在业务import

/**
 *根据域名获取国家地区
 * @returns Country flag
 */
export function getCountry() {
  const host = window.location.host;
  const reg = /speedbiz(\.|-|[0-9a-zA-Z])*(\.|-)my/;

  if (host === "speedbiz.gtech.asia" || host === "speedbiz-operation.gtech.asia" || reg.test(host)) {
    return "my";
  } else {
    return "china";
  }
}
